import React from 'react';
import { Star } from 'lucide-react';
export function SocialProofStrip() {
  return <div className="bg-brand-alt-bg py-8 px-4 border-y border-brand-accent/20" data-id="element-180">
      <div className="max-w-4xl mx-auto flex flex-col items-center justify-center text-center gap-3" data-id="element-181">
        <div className="flex gap-1" data-id="element-182">
          {[...Array(5)].map((_, i) => <Star key={i} className="text-brand-cta fill-brand-cta w-5 h-5 sm:w-6 sm:h-6" data-id="element-183" />)}
        </div>
        <p className="text-lg sm:text-xl font-serif text-brand-text italic" data-id="element-184">
          "Elegido por mujeres que quieren aprender algo lindo, creativo y con
          potencial para emprender"
        </p>
      </div>
    </div>;
}